import { Navigate } from "react-router-dom";

import { Layout } from "antd";
import Sidebar from "../../containers/sidebar/Sidebar";

const { Content } = Layout;

function PrivateRoute({ path, isAuthenticated, children }) {

  let currentLink = window.location.pathname;
  
  console.log("PrivateRoute", isAuthenticated, path, currentLink )
  
  return isAuthenticated ? (
    <Layout className="app-shell">
      <Sidebar currentLink={currentLink} />
      <Content className="app-main">{children}</Content>
    </Layout>
  ) : (
    <Navigate
      to={{
        pathname: "/",
        state: { from: path },
      }}
    />
  );
}

export default PrivateRoute;
